export const BidayuhMenCostList = [
  {
    img_src: "https://66.media.tumblr.com/795d62b9f68603e80c8d70053eb4a9f5/560393e895ab1b7a-d5/s540x810/0ff1a601782e94decf10532c6c1e501de0f27b1c.png",
    alt: 'head-gear',
    name: "Head Gear",
    description: "A Bidayuh men head gear is almost the same as Bipoerh. It is embroidered with red, yellow, and white yarn. Almost all Bidayuh sub-ethnics in Sarawak uses this same headwear.",
  },

  {
    img_src: "https://66.media.tumblr.com/b93ae15ef5aec93386c79f5202e81a9d/81f16984bb421dc4-88/s500x750/132dace702c316cb2ecc2b752a3dbe874ba5de28.png",
    alt: 'pakaian-lelaki-padawan',
    name: "Pakaian Lelaki Padawan",
    description: "This costume is worn by the Bidayuh sub-ethnic residing in Padawan. It is a vest-like clothing that is used during a ceremony.",
  },

  {
    img_src: "https://66.media.tumblr.com/6c32ec33f330c6c78575aeb07a8f4e86/81f16984bb421dc4-55/s540x810/a5655887127605f5e468f6725a89a68bd4b37e02.png",
    alt: 'pakaian-lelaki-bau-lundu',
    name: "Pakaian Lelaki Bau & Lundu",
    description:   "Selakau/Lara and Jagoi/Singai are the Bidayuh sub-ethnics at Bau and Lundu. This costume is worn by men from these sub-ethnics.",
  },

  {
    img_src: "https://66.media.tumblr.com/2d4bfccd1a7d3001e122a32c07dab203/81f16984bb421dc4-aa/s1280x1920/9ba70149ebe7ac86bc25f7efc7e7ad6d87fe867a.png",
    alt: 'pimulang',
    name: "Pimulang",
    description: "Pimulang is an accessory worn by Bidayuh warriors and it is made out of fangs of a tiger. It is considered as a tool to call upon spirits. It is also used during worships or healing ceremonies.",
  },

  {
    img_src: "https://66.media.tumblr.com/ef9c7c85d5b9ddc6fdc423f226ba97fa/81f16984bb421dc4-35/s1280x1920/f0ccf787c041b74e3ffa54dc95863da6578f6b86.png",
    alt: 'pimulang',
    name: "Sirambuk",
    description: "Sirambuk comes in various designs. It is an accessory used by men on their neck to symbolise bravery.",
  },

  {
    img_src:"https://66.media.tumblr.com/b7926913fc9434edbf58648c51f858d2/560393e895ab1b7a-60/s1280x1920/e30c64219692fd109dd2d0191d9caa8e1d2ae78a.png",
    alt: 'pakaian-lelaki-biatah',
    name: "Pakaian Lelaki Biatah",
    description:"This is another costume worn by the Bidayuh sub-ethnic in Padawan although not all. In addition, the vest was made out of animal’s skin therefore it was worn during special occasion.",
  },

];

export const BidayuhWomenCostList = [
  {
    img_src: "https://66.media.tumblr.com/a69a4ece408054601e37930d134ca45c/560393e895ab1b7a-b7/s1280x1920/b02b25e8fe095e4d1472e7204f8437b6f4267c39.png",
    alt: 'biperoh',
    name: "Biperoh",
    description: "Biperoh is a head accessory when dressing in the Bidayuh traditional skirt. It is made with yellow, red, and white yarns. Most Bidayuh sub-ethnics in Bau and Kuching wears it.",
  },

  {
    img_src: "https://66.media.tumblr.com/2791e3a0666a7c886333af50dc412906/81f16984bb421dc4-7c/s540x810/cdb10191246964ea3fc76253c74fbbf91564c019.png",
    alt: 'pakaian-perempuan-bau-lundu',
    name: "Pakaian Perempuan Bau dan Lundu",
    description: "Women of the Bau and Lundu sub-ethnics dressses in white Jipo shirts and black satin skirts. Also in this costume, the women paired them with red sash, red belt adorn with silver coins",
  },

  {
    img_src: "https://3.bp.blogspot.com/-Q-UaUgfkFy0/V6wS1hqVYvI/AAAAAAAAABM/usKZWYE0L2IJt6D2itmyhGMlfch0eafTwCLcB/s320/Z.jpg",
    alt:'pakaian-perempuan-serian',
    name: "Pakaian Perempuan Serian",
    description: "This costume is for the Bidayuh sub-ehtnic Bukar/Sadong from the Serian area ",
  },

  {
    img_src: "https://66.media.tumblr.com/291a4a4f2d0458e21e78ce71d6410d33/81f16984bb421dc4-37/s1280x1920/e52782340210376f4d8162624662918dee59b83f.png",
    alt: 'selempang',
    name: "Selempang",
    description: "Selempang or a sash is worn over the shoulder. It is usally in red. During a dance, the tip of the clothis will be tied on the finger.",
  },

  {
    img_src: "https://66.media.tumblr.com/0abfd18c373d590c97008c992debe8af/81f16984bb421dc4-b3/s1280x1920/7bf2562afadf3da164b36061a2053cf2641828d3.png",
    alt: 'siloung',
    name: "Silo'ung",
    description: "Previously, Silo'ung was used by Dayung Borih (or a High Priestess) during the period of healing from a disease called 'Onam Borih' through a ritual called 'Kabalih'. Silo'ung is made of colourful beads and was by the Bidayuh sub-ethnic at Jagoi/Bratak.",
  },

  {
    img_src: "https://66.media.tumblr.com/9ebca0f1751afe1d86c70ac75006773e/81f16984bb421dc4-b2/s1280x1920/b8b71b8403ce636b56d7989bbcfadc7ad87f3680.png",
    alt:'skirt-tingket',
    name: "Skirt and Tingket",
    description: "Tingket is a belt made out of silver that is paired with a skirt. The accessory is normally used by Bidayuh women in the Serian area. ",
  },

  {
    img_src:"https://66.media.tumblr.com/ead89beda7758da1ddf847cf3deabc38/560393e895ab1b7a-c9/s1280x1920/3847a37fe4e203f808aa7c35f356e260b3fc057c.png",
    alt:'pakaian-perempuan-selakau-selako-lara',
    name:"Pakaian Perempaun Selakau / Selako / Lara",
    description:"The Pakaian perempuan Bidayuh Selakau/Selako is worn by women from the Lundu area during the festivities. The shirt is white and the skirt is black. The clothing is adorn by its own accessory.",
  },

  {
    img_src:"https://66.media.tumblr.com/6775c1feb64f5b845a437ad232a97655/560393e895ab1b7a-50/s1280x1920/ff2ac64ae457d56cf3101b063d8a40c96bf1c6c9.png",
    alt:'baieh',
    name:"Baieh",
    description:"Baieh is a headgear worn by Bidayuh women in Lundu. It has a fairly simple design with not much embellishments.",
  },

  {
    img_src:"https://66.media.tumblr.com/d418221e32949a2a8b19cbdee65ac218/560393e895ab1b7a-ea/s1280x1920/842e8ddfa8235e705b3eb6ec7f59e8b656c2bbfe.png",
    alt:'sombon',
    name:"Sombon",
    description:"Sombon is an accessory that is draped over the shoulders. It is long and made out of large, colourful beads. ",
  },

];